import request from '@/utils/request'

// Excel 导入批次记录
export function importLogList(params) {
  return request.get('/import/logList', { params: params || {} })
}